import Phaser from 'phaser';

class BunnyEscapeScene extends Phaser.Scene {
  constructor() {
    super('BunnyEscapeScene');
  }

  preload() {
    // Load assets if needed
  }

  create() {
    const tileSize = 32;
    const rows = 15;
    const cols = 15;

    // Create a grid with enough empty spaces to allow a path to the exit
    this.grid = Array(rows).fill(0).map(() => Array(cols).fill(1));

    // Ensure there is a path from the bunny to the exit
    const path = this.generatePath(rows, cols);
    for (const [x, y] of path) {
      this.grid[y][x] = 0; // Mark as empty
    }

    // Render the grid and make tiles draggable
    this.tiles = [];
    for (let y = 0; y < rows; y++) {
      for (let x = 0; x < cols; x++) {
        const color = this.grid[y][x] === 1 ? 0xaaaaaa : 0xffffff; // Tile vs Empty
        const tile = this.add.rectangle(x * tileSize, y * tileSize, tileSize, tileSize, color).setOrigin(0);
        tile.setInteractive();
        this.input.setDraggable(tile);
        this.tiles.push({ tile, x, y });
      }
    }

    // Place the bunny in the top-left corner
    this.bunny = this.add.rectangle(16, 16, 24, 24, 0xff0000).setOrigin(0);

    // Place the exit in the second half of the bottom or right side
    const exitX = Phaser.Math.Between(Math.floor(cols / 2), cols - 1);
    const exitY = Phaser.Math.Between(Math.floor(rows / 2), rows - 1);
    this.exit = this.add.rectangle(exitX * tileSize, exitY * tileSize, tileSize, tileSize, 0x00ff00).setOrigin(0);

    // Add monsters randomly
    this.monsters = [];
    for (let i = 0; i < 5; i++) {
      const monsterX = Phaser.Math.Between(0, cols - 1);
      const monsterY = Phaser.Math.Between(0, rows - 1);
      const monster = this.add.rectangle(monsterX * tileSize, monsterY * tileSize, 24, 24, 0x0000ff).setOrigin(0);
      this.monsters.push(monster);
    }

    // Handle drag events for tiles
    this.input.on('dragstart', (pointer, gameObject) => {
      gameObject.setFillStyle(0xffff00); // Highlight the tile being dragged
    });

    this.input.on('drag', (pointer, gameObject, dragX, dragY) => {
      gameObject.x = dragX;
      gameObject.y = dragY;
    });

    this.input.on('dragend', (pointer, gameObject) => {
      const x = Math.floor(gameObject.x / tileSize);
      const y = Math.floor(gameObject.y / tileSize);

      // Snap the tile back to the grid
      gameObject.x = x * tileSize;
      gameObject.y = y * tileSize;

      // Update the grid state
      this.grid[y][x] = 0; // Mark as empty
      gameObject.setFillStyle(0xffffff); // Reset color
    });
  }

  generatePath(rows, cols) {
    const path = [];
    let x = 0;
    let y = 0;

    while (x < cols - 1 || y < rows - 1) {
      path.push([x, y]);

      if (x < cols - 1 && y < rows - 1) {
        if (Math.random() > 0.5) {
          x++;
        } else {
          y++;
        }
      } else if (x < cols - 1) {
        x++;
      } else {
        y++;
      }
    }

    path.push([x, y]); // Add the exit point
    return path;
  }

  update() {
    // Check if monsters reach the bunny
    for (const monster of this.monsters) {
      if (Phaser.Geom.Intersects.RectangleToRectangle(monster.getBounds(), this.bunny.getBounds())) {
        console.log('Game Over: Bunny was eaten!');
        this.scene.restart();
        return;
      }
    }

    // Check if bunny reaches the exit
    if (Phaser.Geom.Intersects.RectangleToRectangle(this.bunny.getBounds(), this.exit.getBounds())) {
      console.log('You Win: Bunny escaped!');
      this.scene.restart();
    }
  }
}

export default BunnyEscapeScene;